import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { Router } from '@angular/router';
import { IPlatformStorage, WEB_STORAGE } from '@common/utils';
import { isExternalUserJwt, JwtResponseDto } from '@portal/shared/utils';

@Component({
    templateUrl: './not-found-page.component.html',
    imports: [MatIcon, MatButton],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotFoundPageComponent {
    private readonly _portalAuthTokenKey: string = 'authUserToken';
    private readonly _router: Router = inject(Router);
    private readonly _storage: IPlatformStorage = inject(WEB_STORAGE);

    readonly isExternalPortalSession: boolean = this._resolveExternalPortalSession();

    onGoHomeClick(): void {
        void this._router.navigate(['/'], { replaceUrl: true });
    }

    private _resolveExternalPortalSession(): boolean {
        const jwt: JwtResponseDto | null = this._storage.getItem<JwtResponseDto>(this._portalAuthTokenKey);

        if (!jwt) {
            return false;
        }

        return isExternalUserJwt(jwt);
    }
}
